import Api from './api';

const slug = 'v1/roleplay-categories';

export default {
  getProgramAvailableCategories(programId) {
    return new Promise((resolve, reject) => {
      const params = programId ? { program: programId } : {};

      Api.get(`/${slug}/program-available`, { params })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getProgramSelectedCategories(programId, language) {
    return new Promise((resolve, reject) => {
      const params = programId ? { program: programId } : {};
      if (language) params.language = language;
      Api.get(`/${slug}/program-picked`, { params })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getRoleplayCategory(categorySlug) {
    return new Promise((resolve, reject) => {
      Api.get(`/${slug}/${categorySlug}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};
